import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';
import {
  baseUniDriverFactory,
  findByHook,
  getDataAttributeValue,
} from '../utils/test-utils/unidriver';
import { dataHooks, dataAttr } from './constants';
import { UniDriver } from '@wix/unidriver-core';

export type ToggleButtonUniDriver = ReturnType<
  typeof toggleButtonDriverFactory
>;

export const toggleButtonDriverFactory = (base: UniDriver, body: UniDriver) => {
  const buttonBaseElement = findByHook(base, dataHooks.button);
  const tooltipBaseElement = base;
  const tooltipDriver = tooltipDriverFactory(tooltipBaseElement, body);
  const buttonDriver = buttonCoreDriverFactory(buttonBaseElement);

  async function getLabelPlacement(): Promise<string | null> {
    return getDataAttributeValue(buttonBaseElement, dataAttr.placement);
  }

  function getTooltipText() {
    return tooltipDriver.getTooltipText();
  }

  return {
    ...baseUniDriverFactory(buttonBaseElement),
    /**
     * Checks whether ToggleButton is disabled
     */
    isButtonDisabled: buttonDriver.isButtonDisabled,
    /**
     * Gets the ToggleButton skin
     */
    getSkin: async (): Promise<string | null> =>
      await getDataAttributeValue(buttonBaseElement, dataAttr.skin),
    /**
     * Checks whether ToggleButton is selected
     */
    isButtonSelected: async (): Promise<boolean> =>
      (await getDataAttributeValue(buttonBaseElement, dataAttr.selected)) ===
      'true',
    /**
     * Gets the ToggleButton label placement
     */
    getLabelPlacement,
    /**
     * Gets the ToggleButton label placement value
     */
    getLabelValue: async (): Promise<string | null> => {
      const placement = await getLabelPlacement();

      if (placement === 'tooltip') {
        return getTooltipText();
      }

      return findByHook(buttonBaseElement, dataHooks.label).text();
    },
    /**
     * Gets the ToggleButton shape
     */
    getShape: async (): Promise<string | null> =>
      await getDataAttributeValue(buttonBaseElement, dataAttr.shape),
  };
};
